import { Reels } from '$core/Reels/Reels';
import { useRoute, useRouter } from 'react-router5';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '$store/rootReducer';
import {
  listReelsByIdSelector,
  listReelsLoadingStatusSelector,
  listReelsStartFromByIdSelector,
  reelsActions,
  reelsActiveIndexSelector,
} from '$store/reels';
import { useCallback, useEffect } from 'react';
import { followersActions } from '$store/followers';
import { useCurrentUserInfo } from '$hooks';
import { goBack } from '$navigation/helper';

export const ReelsClips = () => {
  const { route } = useRoute();
  const router = useRouter();
  const activeIndex = useSelector(reelsActiveIndexSelector);
  const user = useCurrentUserInfo();
  const modelId = route.params.id;
  const reels = useSelector((state: RootState) => listReelsByIdSelector(state, modelId));
  const loadingStatus = useSelector((state: RootState) =>
    listReelsLoadingStatusSelector(state, modelId),
  );
  const startFrom = useSelector((state: RootState) =>
    listReelsStartFromByIdSelector(state, modelId),
  );
  const isClipsLoaded = reels.length > 0;
  const dispatch = useDispatch();
  const activeIndexInitial =
    route.params.activeIndex > reels.length - 1
      ? reels.length - 1
      : route.params.activeIndex;

  const loadData = useCallback(() => {
    dispatch(reelsActions.loadList({ list: `profile_${modelId}` }));
  }, []);

  const loadReels = useCallback(() => {
    dispatch(
      reelsActions.loadList({ list: `profile_${modelId}`, startFrom, replace: false }),
    );
  }, [startFrom]);

  useEffect(() => {
    dispatch(reelsActions.setActiveIndex(route.params.activeIndex));
    if (user.id) {
      dispatch(followersActions.load(user.id));
    }
    if (!isClipsLoaded) {
      dispatch(reelsActions.loadList({ list: `profile_${modelId}` }));
    }
  }, []);

  useEffect(() => {
    if (reels.length === 0 && loadingStatus === '') {
      goBack();
    }
  }, [reels.length, loadingStatus]);

  useEffect(() => {
    router.navigate(route.name, { ...route.params, activeIndex }, { replace: true });
  }, [activeIndex]);

  return (
    <Reels
      loadReels={loadReels}
      loadData={loadData}
      reels={reels}
      loadingStatus={loadingStatus}
      activeIndexInitial={+activeIndexInitial}
    />
  );
};
